<template>
  <proa-card flat class="invite-signed-in-user-card">
    <div class="content-wrapper">
      <router-link :to="{ name: 'root' }" class="logo">
        <img :src="require('@/assets/images/logo.png')"/>
      </router-link>
      <template v-if="rejected">
        <div class="result">
          <img :src="require('@/assets/images/reject.png')"/>
        </div>
        <div class="result-rejected">{{ $t('pages.inviteUser.inviteCard.rejectedInvitationHeader') }}</div>
        <div class="result-body">{{ $t('pages.inviteUser.inviteCard.rejectedInvitationBody') }}</div>
        <div>
          <proa-button
            class="w-100"
            type="submit"
            variant="outline-primary"
            @click.native="onClickToTop"
          >
            {{ $t('pages.inviteUser.inviteCard.toTopOfSharewind') }}
          </proa-button>
        </div>
      </template>
      <template v-else-if="approved">
        <div class="result">
          <img :src="require('@/assets/images/approve.png')"/>
        </div>
        <div class="font-weight-w6">{{ organizationName }}</div>
        <div class="mt-3">{{ $t('pages.inviteUser.inviteCard.wasRegisteredMember') }}</div>
        <div class="result-body">{{ $t('pages.inviteUser.inviteCard.approvedInvitationBody') }}</div>
        <div>
          <proa-button
            class="w-100"
            type="submit"
            variant="outline-primary"
            @click.native="onClickToTop"
          >
            {{ $t('pages.inviteUser.inviteCard.toTopOfSharewind') }}
          </proa-button>
        </div>
      </template>
      <template v-else>
        <span class="welcome-message">{{ $t('common.welcomeToSharewind') }}</span>
        <div class="invite-from">
          <span class="font-weight-w6">{{ organizationName }}</span>
          <span>{{ $t('pages.inviteUser.inviteCard.receivedInvitation') }}</span>
        </div>
        <div>
          <proa-button
            class="w-100"
            type="submit"
            variant="primary"
            :loading="httpRequesting"
            @click.native="$emit('onClickApproveInvitation')"
          >
            {{ $t('pages.inviteUser.inviteCard.approveInvitation') }}
          </proa-button>
        </div>
        <div
          :class="['reject-invitation', { 'disabled': httpRequesting }]"
          @click="$emit('onClickRejectInvitation')"
        >
          {{ $t('pages.inviteUser.inviteCard.rejectInvitation') }}
        </div>
      </template>
    </div>
  </proa-card>
</template>

<script>
export default {
  name: 'InviteSignedInUserCard',
  props: {
    organizationName: String,
    httpRequesting: Boolean,
    rejected: Boolean,
    approved: Boolean
  },
  methods: {
    onClickToTop: function() {
      location.href = '/'
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.invite-signed-in-user-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.content-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    display: block;
    margin-bottom: 40px;

    img {
      width: 150px;
    }
  }

  .result {
    margin-bottom: 20px;

    img {
      width: 60px;
    }
  }

  .result-rejected {
    color: $error-color;
  }

  .result-body {
    white-space: pre-wrap;
    margin: 40px 0;
  }

  .welcome-message {
    color: $primary-color;
    font-weight: 600;
  }

  .invite-from {
    margin: 40px 0;

    span {
      display: block;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .reject-invitation {
    cursor: pointer;
    color: $link-color;
    margin-top: 40px;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
